import e, { forwardRef as a, createElement as r } from "react";
import t from "tiny-invariant";
import { Box as i } from "react-polymorphic-box";
import { isAnchorOnly as o, extractAnchor as n, isInternal as s } from "@walltowall/helpers";

function d() {
  return (d = Object.assign || function (e) {
    for (var a = 1; a < arguments.length; a++) {
      var r = arguments[a];

      for (var t in r) Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
    }

    return e;
  }).apply(this, arguments);
}

const p = a(({
  x: e,
  y: a,
  children: o,
  ...n
}, s) => (t(e > 0, "Prop x must be a number greater than 0."), t(a >= 0, "Prop y must be a number greater than or equal to 0."), r(i, d({
  ref: s,
  as: "div",
  "data-siamese-aspect-ratio": ""
}, n), r("div", {
  "data-siamese-aspect-ratio-spacer": "",
  "aria-hidden": !0,
  style: {
    paddingTop: a / e * 100 + "%"
  }
}), r("div", {
  "data-siamese-aspect-ratio-inner": ""
}, o))));
p.displayName = "AspectRatio";
const m = a(({
  ref: e,
  maxWidth: a,
  innerProps: t,
  children: o,
  ...n
}, s) => r(i, d({
  ref: s,
  as: "div"
}, n), r("div", d({
  "data-siamese-bounded-view-inner": "",
  style: {
    maxWidth: a
  }
}, t), o)));
m.displayName = "BoundedView";
const l = a(({
  ref: e,
  ...a
}, t) => r(i, d({
  ref: t,
  as: "div",
  "data-siamese-gatsby-image-container": ""
}, a)));
l.displayName = "GatsbyImageContainer";
const c = e.forwardRef(({
  ref: a,
  href: r,
  routerLinkComponent: t = "a",
  ...p
}, m) => {
  var l;
  const c = o(r) ? null != (l = n(r)) ? l : "" : r,
        f = s(c),
        h = !f && !c.startsWith("http");
  return e.createElement(i, d({
    ref: m,
    as: f ? t : "a",
    href: c,
    target: f || h ? void 0 : "_blank",
    rel: f || h ? void 0 : "nofollow noopener noreferrer"
  }, p));
});
c.displayName = "Link";
export { p as AspectRatio, m as BoundedView, l as GatsbyImageContainer, c as Link };